import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';

/**
 * Initialize Scroll
 *
 * @return {Void}
 */
$(window).on("load",function(){
  $(".js-custom-scroll").mCustomScrollbar({
    axis:"x", // horizontal scrollbar,
    advanced:{ updateOnContentResize: true }
  });
});
